import { useTranslation } from 'next-i18next'
import { Input } from '@gate/gui'
import { useStore } from '@/store/index'
import { stopEvent } from '@/utils/tools'
import { FundingFilterType } from '../index'
import React, { useState, ChangeEvent, useMemo } from 'react'
import { FundingFilterRoundsStyled, FundingFilterRoundsItemStyled, FundingFilterRoundsBoxStyled } from '../style'

const FFTags: React.FC<FundingFilterType> = ({ itemValue, handleChangeValue }) => {
  const { t } = useTranslation('fundraising')

  const [searchValue, setSearchValue] = useState<string>('')

  const { fundraising } = useStore().baseStore

  const handleSearch = (val: string) => {
    setSearchValue(val)
  }

  const currentTagsSelect = useMemo(() => {
    const tagsSelect: any[] = fundraising?.tagSelect?.list ?? []

    if (searchValue?.length) {
      return tagsSelect?.filter(item => item?.label?.toLocaleLowerCase()?.includes(searchValue?.toLocaleLowerCase()))
    }

    return tagsSelect
  }, [searchValue, fundraising?.tagSelect?.list])

  const currentSelectTags = itemValue?.split(',') ?? []

  return (
    <>
      <Input
        mt={8}
        mb={12}
        icon={
          <svg className="iconpark-icon size-16">
            <use href="#v31-16px-line-sousuo"></use>
          </svg>
        }
        placeholder={t('p.search.tag') as string}
        size="md"
        type="primary"
        styles={{ input: { width: '100%', borderRadius: 20 } }}
        value={searchValue}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          handleSearch(e.target.value)
        }}
        onClear={() => {
          handleSearch('')
        }}
      />

      <FundingFilterRoundsStyled>
        <FundingFilterRoundsBoxStyled>
          {[
            {
              value: '',
              label: t('p.all'),
            },
            ...currentTagsSelect,
          ]?.map(item => {
            return (
              <FundingFilterRoundsItemStyled
                data-focus={currentSelectTags?.some(curItem => curItem === item?.value)}
                key={item?.value}
                onClick={e => {
                  stopEvent(e)

                  if (item?.value?.length === 0) {
                    handleChangeValue('')
                    return
                  }

                  if (currentSelectTags?.some(curItem => curItem === item?.value)) {
                    const newTagList = currentSelectTags.filter(fItem => fItem !== item?.value || fItem?.length === 0)

                    handleChangeValue(newTagList?.join(','))
                  } else {
                    const currentNewTags = [...currentSelectTags, ...[item?.value]]?.filter(
                      fItem => fItem?.length !== 0
                    )

                    handleChangeValue(currentNewTags?.join(','))
                  }
                }}
              >
                {item?.label}
              </FundingFilterRoundsItemStyled>
            )
          })}
        </FundingFilterRoundsBoxStyled>
      </FundingFilterRoundsStyled>
    </>
  )
}

export default FFTags
